import { render, staticRenderFns } from "./PortalOfficeNoIbowEdit.vue?vue&type=template&id=6e4180e2&scoped=true&"
import script from "./PortalOfficeNoIbowEdit.vue?vue&type=script&lang=ts&"
export * from "./PortalOfficeNoIbowEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PortalOfficeNoIbowEdit.vue?vue&type=style&index=0&id=6e4180e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4180e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VSimpleTable,VSnackbar,VSpacer})
